import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import pick from 'lodash/pick';
import Pricing from './pricing';
import CheckoutForm from './CheckoutForm';

import {
  Modal,
  ModalBody
} from 'reactstrap';
import ModalHeader from '../reactstrap/ModalHeader';



const modalPropKeys = Object.keys(Modal.propTypes);

const mapStateToProps = state => ({ currentProject: state.currentProject });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({  }, dispatch)
};

class ActivateModal extends Component {
  
  constructor (props){
    super(props)
    
    this.selectPlan = this.selectPlan.bind(this);
    this.onSuccess = this.onSuccess.bind(this);
    
    this.state = {
      plan: null,
      token: null,
      loading: false,
      changeCard: false,
      subscribeError: false
    }
  }
  
  selectPlan (plan){
    // const { id, annual } = plan || {id: 'pro'};
    this.setState({plan: plan});
  }
  
  onSuccess () {
    const { toggle } = this.props;
    toggle();
    // window.location.reload();
  }
  
  render() {
    const { currentProject, toggle, ...otherProps } = this.props;
    const modalProps = pick(otherProps, modalPropKeys);
    const { plan } = this.state;
    
    return (
      <Modal {...modalProps} centered={true}>
        <ModalHeader toggle={toggle} className="text-center">Upgrade Subscription</ModalHeader>
        <ModalBody className="activate-modal">
          {!plan && <Pricing onSuccess={this.selectPlan} />}
          {plan && <CheckoutForm plan={plan} onSuccess={this.onSuccess} />}
        </ModalBody>
      </Modal>
    );
  }
  
}

export default connect(mapStateToProps, matchDispatchToProps)(ActivateModal);



// WEBPACK FOOTER //
// ./src/components/billing/activateModal.js